import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import SmallBodyFont from '../../../Theme/Fonts/SmallBody'

export type SegmentedControlButtonProps = {
    label: string
    selected?: boolean
    onPress?: () => void
    testID?: string
}

const SegmentedControlButton: FunctionComponent<SegmentedControlButtonProps> = ({
    label,
    selected,
    onPress,
    testID,
}) => {
    return (
        <Grid minWidth={0} testID={testID}>
            <Touchable expand onPress={onPress}>
                <Grid
                    backgroundColor={selected ? 'moon-2' : 'TRANSPARENT'}
                    borderRadius={16}
                    height={32}
                    centerVertical
                    paddingX={4}
                >
                    <SmallBodyFont
                        textAlign="center"
                        numberOfLines={1}
                        bold={selected}
                        color={selected ? 'onyx' : 'keshi-3'}
                    >
                        {label}
                    </SmallBodyFont>
                </Grid>
            </Touchable>
        </Grid>
    )
}

export default SegmentedControlButton
